module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/remortgage-linechart-sm-63c4d4d1e2e3da37d1c215532518b197.svg";